import { render } from "./CheckboxComponent.vue?vue&type=template&id=1dc8015e&ts=true"
import script from "./CheckboxComponent.vue?vue&type=script&lang=ts"
export * from "./CheckboxComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__